"use client";

import { useState } from "react";
import iconDefaultLeague from "@/assets/images/demo-2/icon-default-league.svg";

const ChevronIcon = ({ expanded }) => (
  <svg
    className={`h-[20px] w-[20px] frost-text-label-muted transition-transform duration-200 ${
      expanded ? "rotate-180" : ""
    }`}
    viewBox="-4 -4 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export default function USMatchLeagues({
  league,
  matches = [],
  render = () => null,
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  const leagueName = league?.nameVN || league?.name || "Giải đấu";
  const leagueLogo = league?.logo || league?.leagueLogo || league?.icon || league?.image;

  return (
    <div className="rounded-2xl overflow-hidden mb-3">
      <div
        role="button"
        tabIndex={0}
        className="flex w-full max-w-full items-center justify-between gap-3 bg-[var(--theme-bg)] px-1 md:px-4 py-1 md:py-3 text-left border-0 rounded-2xl overflow-hidden"
        aria-expanded={isExpanded ? "true" : "false"}
        onClick={() => setIsExpanded((p) => !p)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsExpanded((p) => !p);
          }
        }}
      >
        <div className="flex min-w-0 flex-1 items-center gap-2.5">
          <img
            src={leagueLogo || iconDefaultLeague}
            className="h-[22px] w-[22px] object-contain"
            alt="league"
          />
          <div className="min-w-0 truncate text-[18px] font-bold leading-[1.4] frost-text-label-muted">
            {leagueName}
          </div>
        </div>

        <span className="mr-2 md:mr-6 grid h-[24px] w-[24px] md:h-[36px] md:w-[36px] shrink-0 place-items-center rounded-[10px] bg-[var(--theme-accent)]">
          <ChevronIcon expanded={isExpanded} />
        </span>
      </div>

      {isExpanded ? (
        <div className="mt-3">
          <div className="rounded-2xl border-[0.88px] border-solid frost-border-faint bg-[var(--theme-bg)] p-0 transition hover:border-[var(--theme-primary)]">
            <div className="bg-[var(--theme-bg)]">
              {matches.map((match, idx) => (
                <div key={match?.id || idx}>
                  {render(match, idx)}
                  {idx < matches.length - 1 ? (
                    <div className="mx-4 border-b border-[var(--theme-border)]" />
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
